export default __webpack_public_path__ + "static/media/machine.25d052b7.svg";